import { Badge } from "@/components/ui/badge";
import { Crown, Zap } from "lucide-react";
import { PlanType } from "@/hooks/useSubscription";

interface PlanBadgeProps {
  plan: PlanType;
}

export const PlanBadge = ({ plan }: PlanBadgeProps) => {
  if (plan === "free") {
    return <Badge variant="outline">Free</Badge>;
  }

  if (plan === "premium") {
    return (
      <Badge className="bg-primary">
        <Crown className="h-3 w-3 mr-1" />
        Premium
      </Badge>
    );
  }

  return (
    <Badge className="bg-gradient-to-r from-primary to-purple-600">
      <Zap className="h-3 w-3 mr-1" />
      Pro
    </Badge>
  );
};
